import React from "react";
import { Form } from "react-bootstrap";
import { AsyncPaginate } from "react-select-async-paginate";
import { request } from "../../api/http";
import { buildListQuery } from "../../api/query";
import { SelectLoadingIndicator } from "../../shared/UxbiSpinner";

export async function loadSatUnits(search, page = 1) {
  const filters = search
    ? [
        {
          condition: "AND",
          group: ["clave", "nombre"].map((property) => ({
            property,
            operator: "LIKE",
            value: search,
            condition: "OR",
          })),
        },
      ]
    : [];
  const data = await request(
    `facturacion/catalogos/sat/unidades_medida?${buildListQuery({ page, limit: 25, filters })}`,
  );
  return {
    options: data.data || [],
    hasMore: page < Number(data.last_page || 1),
    additional: { page: page + 1 },
  };
}
export default function SatUnitSelect({
  value,
  description,
  onChange,
  disabled,
}) {
  return (
    <Form.Group className="mb-3" controlId="unit-sat-key">
      <Form.Label>Clave de unidad SAT</Form.Label>
      <AsyncPaginate
        inputId="unit-sat-key"
        value={value ? { clave: value, nombre: description || "" } : null}
        loadOptions={(search, loaded, { page }) => loadSatUnits(search, page)}
        additional={{ page: 1 }}
        getOptionValue={(option) => String(option.clave)}
        getOptionLabel={(option) =>
          `${option.clave}${option.nombre ? ` · ${option.nombre}` : ""}`
        }
        onChange={(option) =>
          onChange(option?.clave || "", option?.nombre || "")
        }
        placeholder="Buscar por clave o nombre…"
        isDisabled={disabled}
        isClearable
        debounceTimeout={300}
        components={{ LoadingIndicator: SelectLoadingIndicator }}
        loadingMessage={() => "Cargando unidades SAT…"}
        noOptionsMessage={() => "No hay unidades coincidentes"}
        styles={{ control: (base) => ({ ...base, minHeight: 42 }) }}
      />
      <Form.Text>
        Selecciona la clave oficial utilizada en la facturación.
      </Form.Text>
    </Form.Group>
  );
}
